/**
 * 导航服务
 * 提供类型安全的导航功能
 */

import React from 'react';
import { NavigateFunction, NavigateOptions } from 'react-router-dom';
import { RouteNames, RouteParams, getRoutePath } from './routes.js';

export class NavigationService {
  constructor(
    private navigate: NavigateFunction,
    private startTransition?: React.TransitionStartFunction
  ) {}

  /**
   * 导航到指定路由
   */
  navigateTo<T extends RouteNames>(
    routeName: T,
    params?: RouteParams[T],
    options?: NavigateOptions
  ): void {
    const path = getRoutePath(routeName, params);

    if (this.startTransition) {
      this.startTransition(() => {
        this.navigate(path, options);
      });
    } else {
      this.navigate(path, options);
    }
  }

  /**
   * 返回上一页
   */
  goBack(): void {
    this.navigate(-1);
  }

  /**
   * 获取指定路由的路径
   */
  getPath<T extends RouteNames>(routeName: T, params?: RouteParams[T]): string {
    return getRoutePath(routeName, params);
  }
}
